import { useEffect, useRef, useState } from "react";
import { revealPrompt } from "../Utils/StringUtils";
import { messyBorderStyle } from "../Utils/StyleUtils";
import RevealCanvas from "./Canvas/RevealCanvas";
import featuredArt from "./featuredArt.json";

const FeaturedArt = (props) => {
    const nElements = 4;

    const contentRef = useRef(null);
    const [canvasSize, setCanvasSize] = useState(0);
    const [selection, setSelection] = useState([]);

    useEffect(() => {
        var divStyle = getComputedStyle(contentRef.current);

        var w = contentRef.current.clientWidth;
        w -= parseFloat(divStyle.paddingLeft) + parseFloat(divStyle.marginLeft) + parseFloat(divStyle.paddingRight) + parseFloat(divStyle.marginRight);

        var canvas = w / 2.1
        if (w < 600) {
            canvas = w
        }

        setCanvasSize(canvas)
    })

    useEffect(() => {
        var options = Object.keys(featuredArt);
        var result = [];

        for(var i = 0; i < nElements && options.length; i++) {
            const idx = Math.floor(Math.random() * options.length);
            const drawingId = options.splice(idx, 1);
            result.push(drawingId);
        }

        setSelection(result);
    }, [])

    var centerFieldStyle = {
        flexWrap: 'wrap',
        flexDirection: 'row',
        justifyContent: 'space-around',
        boxSizing: 'border-box',
        padding: '20px',
        margin: '10px',
        backgroundColor: '#FFFFFF',
        maxWidth: '800px',
        display: 'flex',
        ...messyBorderStyle("featured_art"),
    }
    return < div style={centerFieldStyle} ref={contentRef}>
        <div style={{
            width: '100%',
            textAlign: 'center',
            padding: '10px',
            fontSize: '2.5em',
            fontWeight: 'bold',
            fontFamily: 'Fancy Pants NF'
        }}>
            Featured Art
        </div>
        {selection.map((drawingid) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                paddingTop: '.5em',
                paddingBottom: '.5em',
                width: canvasSize,
            }} key={drawingid}>
                <RevealCanvas width={canvasSize}>
                    <img src={"https://i.imgur.com/" + drawingid + ".png"} style={{ width: '100%' }} />
                </RevealCanvas>
                <div style={{
                    fontWeight: 'bold',
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    alignItems: "center",
                    width: canvasSize,
                    boxSizing: 'border-box',
                    paddingTop: '.5em',
                    paddingBottom: '.5em',
                }}>
                    {revealPrompt(featuredArt[drawingid])}
                </div>
            </div>
        })}
    </div >
}

export default FeaturedArt;